export default {
  name: 'rent-relief-eligible',
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    fundName() {
      return this.fund.details.name;
    },
    rentRelief() {
      return this.$store.getters['toolkit/getItemData'];
    },
    property() {
      return this.rentRelief.property;
    },
    fullAddress() {
      return `${this.property.address.street} ${this.property.address.suburb} ${this.property.address.state} ${this.property.address.postCode}`;
    },
    tenantName() {
      if (this.property.tenant.type === 'Trust') {
        return `${this.property.tenant.details.trusteeName} as trustee for ${this.property.tenant.details.trustName}`;
      }
      return this.property.tenant.details.companyName;
    },
    jobKeeper() {
      return this.rentRelief.determination.jobKeeper;
    },
    turnOverLessThan50Million() {
      return this.rentRelief.determination.turnover;
    },
    turnOverPercentage() {
      return this.rentRelief.determination.turnoverReduction;
    },
    turnOverStartDate() {
      return this.rentRelief.determination.relativePeriod.start;
    },
    turnOverEndDate() {
      return this.rentRelief.determination.relativePeriod.end;
    },
    landlordFinancial() {
      return this.rentRelief.adjustments.landlord.hasLandlord;
    },
    landlordAbilities() {
      return this.rentRelief.adjustments.landlord.landlord;
    },
    landlordOtherAbilities() {
      return this.rentRelief.adjustments.landlord.other;
    },
    driverAbilities() {
      return this.rentRelief.adjustments.drivers.drivers;
    },
    driverOtherAbilities() {
      return this.rentRelief.adjustments.drivers.other;
    },
    hasClosure() {
      return this.rentRelief.adjustments.drivers.closure.hasClosure;
    },
    reopenDate() {
      return this.rentRelief.adjustments.drivers.closure.date;
    },
    startDate() {
      return this.rentRelief.adjustments.reduction.startDate;
    },
    reviewDate() {
      return this.rentRelief.adjustments.reduction.reviewDate;
    },
    deferredDate() {
      return this.rentRelief.adjustments.deferralDate;
    },
    reductionPercentage() {
      return this.rentRelief.adjustments.reduction.amount;
    },
    waiverPercentage() {
      return this.rentRelief.adjustments.waiver;
    },
    deferralPercentage() {
      return this.rentRelief.adjustments.deferral;
    },
    hasAccomodations() {
      return this.rentRelief.adjustments.accommodations.hasAccommodations;
    },
    listOtherAccomodations() {
      return this.rentRelief.adjustments.accommodations.accommodations;
    },
    otherAccomodationsOther() {
      return this.rentRelief.adjustments.accommodations.other;
    },
    tenantSignee() {
      return this.property.tenant.details.signee;
    },
    signeePosition() {
      return this.property.tenant.details.position;
    },
    listOfTrustee() {
      return this.fund.trustee.trustees;
    },
    trusteeType() {
      return this.fund.trustee.type;
    },
    formatTrusteesAsString() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`)).join(', ');
    },
    formatTrusteesAsList() {
      return (this.fund.trustee.trustees.flatMap(trustee => `${trustee.firstName} ${trustee.lastName}`));
    },
    formatMembers() {
      return (this.fund.members.flatMap(member => `${member.firstName} ${member.lastName}`)).join(', ');
    },
  },
};
